const LenderIdentificationSchema = {
    lenderName: {
        required: { value: true, message: 'Name is required.' },
        minLength: { value: 2, message: 'Name should be at least 2 characters.' }
    },
    phoneNumber: {
        required: { value: true, message: 'Phone Number is required.' },
        pattern: { value: /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}( x\d{1})?( x\d{2})?( x\d{3})?( x\d{4})?$/, message: 'Phone Number is invalid.' }
    },
    email: {
        required: { value: true, message: 'Email Address is required.' },
        pattern: { value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, message: 'Email Address is invalid.' }
    }
};

export default LenderIdentificationSchema;